const SvgComponent = () => {
  return (
    <svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-label="X"
    >
      <path
        d="M0.287125 8H1.42013L2.34413 6.207C2.52013 5.855 2.70713 5.47 2.90512 5.03H2.98212C3.20213 5.47 3.40013 5.855 3.58713 6.207L4.52213 8H5.71013L3.65313 4.359L5.57812 0.85H4.45613L3.62013 2.544C3.44413 2.874 3.30113 3.193 3.10313 3.633H3.02613C2.80613 3.193 2.65213 2.874 2.47613 2.544L1.60713 0.85H0.419125L2.33313 4.304L0.287125 8Z"
        fill="#910A2D"
      />
    </svg>
  )
}

export default SvgComponent
